<!-- src/components/Footer.vue -->
<template>
  <div class="pie" id="pie">
    <div class="limitado pieT">
      <div class="info">
        <h3>Dystrybutor: 4HiFi Sp. z o.o.</h3>
        <p>ul. Wyczółkowskiego 10<br />44-109 Gliwice</p>
        <p>NIP: 6312647128</p>
      </div>
      <div class="info">
        <p>&#128386;&nbsp; audio@4hifi.pl</p>
        <p>&#9742; +48 32 810 00 35</p>
        <p>&#9742; +48 530 419 575</p>
      </div>
      <div class="info">
        <p>Godziny otwarcia:</p>
        <p>pon-pt: 9:00 do 17:00<br />soboty, niedziele: nieczynne</p>
      </div>
      <div class="info"><p><a href="https://4hifi.pl/k51,producenci-line-magnetic.html" target="_blank">Sklep</a></p></div>
    </div>
  </div>
</template>

<script setup>
</script>
